// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2EmSm","content":"LayoutSettings_content__1ABwh"};